import { resolveBuildRunNumber } from '@/features/builds/utils/buildRunNumber';
import type { DailyHistoryCell, EntityDailyHistoryRow } from './EntityDailyHistoryPanel.types';

const resolveExecutionRunHref = (
  entityHref: string,
  runLabel: string | null | undefined,
): string | null => {
  if (!runLabel?.startsWith('#')) return null;
  const runNumber = runLabel.slice(1).trim();
  return runNumber.length > 0 ? `${entityHref}/runs/${runNumber}` : null;
};

const resolveBuildRunHref = (
  entityHref: string,
  runLabel: string | null | undefined,
): string | null => {
  const runNumber = resolveBuildRunNumber(runLabel ?? null);
  return runNumber !== null ? `${entityHref}/runs/${runNumber}` : null;
};

export const attachDailyHistoryRunLinks = (
  dailyHistory: DailyHistoryCell[] | undefined,
  entityHref: string,
  entityType: 'suite' | 'test' | 'pipeline',
): DailyHistoryCell[] =>
  (dailyHistory ?? []).map((historyCell) => ({
    ...historyCell,
    details: historyCell.details.map((detail) => ({
      ...detail,
      runHref:
        entityType === 'pipeline'
          ? resolveBuildRunHref(entityHref, detail.runLabel)
          : resolveExecutionRunHref(entityHref, detail.runLabel),
    })),
  }));

export const attachRowDailyHistoryRunLinks = (
  row: EntityDailyHistoryRow,
  entityType: 'suite' | 'test' | 'pipeline',
): EntityDailyHistoryRow => ({
  ...row,
  dailyHistory: attachDailyHistoryRunLinks(row.dailyHistory, row.href, entityType),
  childRows: row.childRows?.map((childRow) => attachRowDailyHistoryRunLinks(childRow, 'test')),
});
